export default __webpack_public_path__ + "static/media/credits.07656eb1.png";